<template>
  <div class="mt90">
    <el-row style="background:#f3f3f3;height:1px"></el-row>
    <el-row class="pr-container bg-white pb-6">
      <h2 class="pr-c-title mt-6 mb-5 text-center f-w500 font34 col333">经典案例-{{ caseTitle }}</h2>
      <div class="pt-5 px-5 clear mw-img100">
        <template v-if="caseId == 1">
          <el-col class="mb-4">
            <h2 class="font26 f-w500 col333">项目介绍</h2>
            <div class="pb-4">
              <p>深圳市云旅通科技有限公司是旅游行业领先的管理+IT服务机构。一直致力于为目的地政府、旅发委（局) 、大中型旅游集团提供目的地旅游智慧营销整体解决方案及为旅游行业不同类型、不同业务、不同规模的旅游企业提供高效实用的IT咨询服务、一体化信息化解决方案及相关联高增值的服务。</p>
              <p>通过16年的行业积累，为旅游目的地城市、特色小镇、全产业链型旅游集团提供相应的信息技术解决方案</p>
            </div>
            <h2 class="font26 f-w500 col333">服务内容</h2>
            <div class="pb-4">
              <p class="f-w700">管理咨询</p>
              <div class="pl-3">
                <p>项目管理流程的梳理、建立及改进</p>
                <p>中高层管理干部关于人员管理及项目管理方面的培训</p>
                <p>敏捷方法论培训及实施</p>
              </div>
              <p class="f-w700">技术咨询</p>
              <div class="pl-3">
                <p>代码管理、缺陷管理、版本管理</p>
                <p>软件体系架构设计、安全架构设计、数据库设计</p>
                <p>技术培训、管理培训及工具使用培训</p>
              </div>
            </div>
            <h2 class="font26 f-w500 col333">项目挑战</h2>
            <div class="pb-4">
              <p>公司总共有50多人的技术团队</p>
              <p>公司管理层销售出身，对开发管理流程不了解，无法发现问题根源并解决问题</p>
              <p>技术团队没有一名有能力的CTO带领</p>
            </div>
            <h2 class="font26 f-w500 col333">客户价值</h2>
            <div class="pb-4">
              <p>引入敏捷管理</p>
              <p>引入技术管理框架及方法论</p>
              <p>引导了公司的项目交付</p>
            </div>
          </el-col>
          <el-col class="mb-5">
            <div class="text-center pt-4"><img src="../../../assets/images/case/detail/2.png" alt=""></div>
          </el-col>
          <el-col class="mb-5">
            <div class="text-center pt-4"><img src="../../../assets/images/case/detail/3.png" alt=""></div>
          </el-col>
        </template>
        <template v-if="caseId == 3">
          <el-col class="mb-5">
            <!-- <h2 class="font26 f-w500 col333">案例介绍-1</h2> -->
            <div class="text-center pt-4"><img src="../../../assets/images/case/detail/5.png" alt=""></div>
          </el-col>
          <el-col class="mb-5">
            <div class="text-center pt-4"><img src="../../../assets/images/case/detail/6.png" alt=""></div>
          </el-col>
          <el-col class="mb-5">
            <div class="text-center pt-4"><img src="../../../assets/images/case/detail/7.png" alt=""></div>
          </el-col>
          <el-col class="mb-5">
            <div class="text-center pt-4"><img src="../../../assets/images/case/detail/8.png" alt=""></div>
          </el-col>
        </template>
        <template v-if="caseId == 4">
          <el-col class="mb-5">
            <div class="text-center pt-4"><img src="../../../assets/images/case/detail/9.png"/></div>
          </el-col>
          <el-col class="mb-5">
            <div class="text-center pt-4"><img src="../../../assets/images/case/detail/10.png"/></div>
          </el-col>
        </template>
        <template v-if="caseId == 5">
          <el-col class="mb-5">
            <div class="text-center pt-4"><img src="../../../assets/images/case/detail/11.png"/></div>
          </el-col>
          <el-col class="mb-5">
            <div class="text-center pt-4"><img src="../../../assets/images/case/detail/12.png"/></div>
          </el-col>
          <el-col class="mb-5">
            <div class="text-center pt-4"><img src="../../../assets/images/case/detail/13.png"/></div>
          </el-col>
        </template>
        <template v-if="caseId == 6">
          <el-col class="mb-5">
            <div class="text-center pt-4"><img src="../../../assets/images/case/detail/14.png"/></div>
          </el-col>
          <el-col class="mb-5">
            <div class="text-center pt-4"><img src="../../../assets/images/case/detail/15.png"/></div>
          </el-col>
          <el-col class="mb-5">
            <div class="text-center pt-4"><img src="../../../assets/images/case/detail/16.png"/></div>
          </el-col>
        </template>
      </div>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'CaseDetail',
  data() {
    return {
      caseTitle: '云旅通',
      caseId: ''
    }
  },
  created() {
    this.getCaseDetail();
  },
  methods: {
    getCaseDetail() {
      this.caseId = this.$route.params.id;
      switch (this.caseId) {
        case '1':
          this.caseTitle = '云旅通';
          break;
        case '3':
          this.caseTitle = '深圳文化产权交易所';
          break;
        case '4':
          this.caseTitle = '爱思拓';
          break;
        case '5':
          this.caseTitle = '大数据风控平台';
          break;
        case '6':
          this.caseTitle = '消费金融核心系统';
          break;
      }
    }
  }
}
</script>

<style lang="scss">

</style>
